import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  Output
} from '@angular/core';

import { disabledProviderFactory, WithDisabled } from '../../helpers';

enum IconGroupSize {
  Default = 'default',
  Small = 'small'
}

enum IconGroupStyle {
  Default = 'default',
  Outline = 'outline',
  Primary = 'primary'
}

@Component({
  selector: 'pcs-icon-group',
  templateUrl: './icon-group.component.html',
  styleUrls: ['./icon-group.component.scss'],
  providers: [
    disabledProviderFactory(IconGroupComponent)
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconGroupComponent implements WithDisabled {

  @Input() iconGroupSize = IconGroupSize.Default;
  @Input() iconGroupStyle = IconGroupStyle.Default;
  @HostBinding('class.disabled')
  @Input() disabled = false;

  @Output() clicked = new EventEmitter();

  @HostBinding('class.icon-group-small')
  private get isSmall() {
    return this.iconGroupSize === IconGroupSize.Small;
  }

  @HostBinding('class.icon-group-outline')
  private get isOutline() {
    return this.iconGroupStyle === IconGroupStyle.Outline;
  }

  @HostBinding('class.icon-group-primary')
  private get isPrimary() {
    return this.iconGroupStyle === IconGroupStyle.Primary;
  }

  @HostListener('click')
  onClicked() {
    if (!this.disabled) {
      this.clicked.emit();
    }
  }

}
